import React, { useState } from 'react';
import styled from '@emotion/styled';
import configuration from '../config';
import getResponse from '../utilities/FetchHelper';

import icon_plus from '../assets/icon_plus.svg';
import icon_minus from '../assets/icon_minus.svg';

const ComfortModalRemoteOverride = ({
  onClose,
  zoneData,
  updateZoneData,
  setShowLoading,
  errorMessage,
  setErrorMessage,
  errorMessageRef,
}) => {
  const [setpoint, updateSetpoint] = useState(72);
  const [postData, setPostData] = useState({
    mode: 'heat',
    setpoint,
    durationInMinutes: 60,
  });

  const decrementSetpoint = () => {
    updateSetpoint(setpoint - 1);
    setPostData((prevState) => ({
      ...prevState,
      setpoint: setpoint - 1,
    }));
  };

  const incrementSetpoint = () => {
    updateSetpoint(setpoint + 1);
    setPostData((prevState) => ({
      ...prevState,
      setpoint: setpoint + 1,
    }));
  };

  const modeOptions = [
    { label: 'Heat', value: 'heat' },
    { label: 'Cool', value: 'cool' },
    { label: 'Off', value: 'off' },
  ];

  const durationOptions = new Array(24).fill(0).map((_, i) => ({
    label: `${i + 1} ${i + 1 > 1 ? 'hours' : 'hour'}`,
    value: (i + 1) * 60,
  }));

  const handleSave = () => {
    setShowLoading({ message: 'Creating remote override...', isLoading: true });
    const clearLoading = () => setShowLoading({ message: '', isLoading: false });
    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        zoneData.thermalZoneEntityKey +
        '/thermalZone/override',
      false,
      'POST',
      `mode=${postData.mode}&` +
        `setpoint=${postData.setpoint}&` +
        `durationInMinutes=${postData.durationInMinutes}`,
      () => {
        clearLoading();
        updateZoneData();
      },
      (val) => {
        if (val === false) clearLoading();
      },
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
    onClose();
  };

  return (
    <StyledOverrideDiv className="modal-homepage-zone-settings modal-temporary-adjustment">
      <div className="temperature-adjustment">
        <div className="setpoint">
          {setpoint}
          <div className="decrement-setpoint" onClick={decrementSetpoint}>
            <img src={icon_minus} alt="decrease icon" width="20" height="20" />
          </div>
          <div className="increment-setpoint" onClick={incrementSetpoint}>
            <img src={icon_plus} alt="increase icon" width="20" height="20" />
          </div>
        </div>
      </div>

      <div className="settings-row">
        <label>Mode</label>
        <div className="setting-input">
          <select
            name="mode"
            onChange={(e) =>
              setPostData((prevState) => ({
                ...prevState,
                mode: e.target.value,
              }))
            }
          >
            {modeOptions.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="settings-row">
        <label>Duration</label>
        <div className="setting-input">
          <select
            name="duration"
            onChange={(e) =>
              setPostData((prevState) => ({
                ...prevState,
                durationInMinutes: parseInt(e.target.value),
              }))
            }
          >
            {durationOptions.map((option) => (
              <option value={option.value} key={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="modal-actions">
        <button className="modal-btn" onClick={onClose}>
          Cancel
        </button>
        <button className="modal-btn cta" onClick={handleSave}>
          Confirm
        </button>
      </div>
    </StyledOverrideDiv>
  );
};

const StyledOverrideDiv = styled.div`
  .settings-row {
    display: flex;
    margin: 0 0 12px;

    > * {
      align-items: center;
      display: flex;
      flex: 1;
    }

    .setting-input {
      justify-content: end;
    }

    label {
      color: #02222b;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
    }
  }

  .temperature-adjustment {
    border-bottom: 2px solid #c2d0d1;
    margin-bottom: 40px;
    padding: 20px;
    text-align: center;

    .setpoint {
      color: #02222b;
      display: inline-block;
      font-size: 72px;
      font-weight: 600;
      letter-spacing: -1.44px;
      line-height: 90px;
      position: relative;

      .decrement-setpoint,
      .increment-setpoint {
        border: 1px solid var(--gray-300, #d0d5dd);
        border-radius: 8px;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 0;
        left: -64px;
        line-height: 1;
        padding: 12px;
        position: absolute;
        transform: translate(0, -50%);
        top: 50%;
      }

      .increment-setpoint {
        left: auto;
        right: -64px;
        text-align: center;
      }
    }
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
`;

export { ComfortModalRemoteOverride };
export default ComfortModalRemoteOverride;
